import React from "react";

import phone from "../../assets/icons/phone.svg";
import email from "../../assets/icons/mail.svg";
import location from "../../assets/icons/location.svg";
import instagram from "../../assets/icons/insta.svg";

const ContactUs = () => {
  return (
    <div className=" w-full text-white font-IRANSansWeb  flex flex-col ">
      <div
        className=" bg-[#f5911e]  px-20 flex flex-col border-2 border-[#f5911e] my-10
          screen1200:px-10 screen800:px-10 screen400:px-0
        "
      >
        <div className=" px-20 p-10 text-2xl font-bold place-self-end screen800:px-10 screen800:text-[18px] screen800:p-2 screen800:my-2 screen1800:text-[26px]">
          تماس با ما
        </div>

        <div className=" w-full flex flex-row pb-10 ">
          <div className=" mx-12 screen800:mx-6 screen600:hidden ">
            <iframe
              title="نقشه سکه شادمهر"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.814312718563!2d51.362611717443855!3d35.70618679999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e01ebc2ab5c8f%3A0xb66721b493af7ac5!2sbiuk%202!5e0!3m2!1sen!2s!4v1674376697783!5m2!1sen!2s"
              width="70"
              height="50"
              className=" w-[250px] h-[200px] mx-auto 
              screen900:w-[200px] screen900:h-[150px] "
            ></iframe>
          </div>

          <div className=" w-full text-right mr-12 screen800:mr-6 screen900:text-[12px] screen500:mx-2 screen1800:text-[20px]  ">
            <div className="  my-4 flex flex-row-reverse ">
              <img
                className=" w-5 h-5 inline mx-3  screen1800:w-7 screen1800:h-7"
                width={26}
                height={26}
                src={location}
                alt="آدرس سکه شادمهر"
              />
              <span>
              ستارخان بهبودی بالاتر از نصرت پلاک ۲۲۱
              </span>
            </div>

            <div className="  my-4 flex flex-row-reverse ">
              <img
                className=" w-5 h-5 inline mx-3  screen1800:w-7 screen1800:h-7"
                width={26}
                height={26}
                src={email}
                alt="ایمیل سکه شادمهر"
              />
              <span>biuk2com@gmail.com</span>
            </div>

            <div className="  my-4 flex flex-row-reverse ">
              <img
                className=" w-5 h-5 inline mx-3  screen1800:w-7 screen1800:h-7"
                width={26}
                height={26}
                src={phone}
                alt="شماره تلفن سکه شادمهر"
              />
              <span>91306125 021 - 09128383745</span>
            </div>

            <div className="  my-4 flex flex-row-reverse ">
              <img
                className=" w-5 h-5 inline mx-3  screen1800:w-7 screen1800:h-7"
                width={26}
                height={26}
                src={instagram}
                alt="اینستاگرام سکه شادمهر"
              />
              <span>Biuk2</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
